import { render } from "./Consolidated2.vue?vue&type=template&id=19f330d2&scoped=true"
import script from "./Consolidated2.vue?vue&type=script&lang=js"
export * from "./Consolidated2.vue?vue&type=script&lang=js"

import "./Consolidated2.vue?vue&type=style&index=0&id=19f330d2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-19f330d2"

export default script